const routerProviders = [
  {
    path: "/fornecedor/historico-transferencia",
    name: "TransferLogProvider",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "TransferLog" */ "@/views/Invoices/TransferLog.vue"
      ),
  },
  {
    path: "/fornecedor/pedidos",
    name: "InvoiceProvider",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "InvoiceProvider" */ "@/views/Provider/Invoices.vue"
      ),
  },
  {
    path: "/fornecedor/importar-produto",
    name: "ImportProductProvider",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ImportProductProvider" */ "@/views/Provider/ImportProduct.vue"
      ),
  },
  {
    path: "/fornecedor/lista-importar",
    name: "ProductListImport",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProductListImport" */ "@/views/Provider/ListImportProduct.vue"
      ),
  },
  {
    path: "/fornecedor/produto/:id",
    name: "ProductViewImport",
    exact: true,
    component: () =>
      import(
        /* webpackChunkName: "ProductViewImport" */ "@/views/Provider/ProductViewImport.vue"
      ),
  },
];

export default routerProviders;
